import { css } from 'styled-components';

export const vgTheme = css`
    --color-primary: var(--color-black);
    
    --color-state-primary: rgba(27, 27, 29, 0.07);
    --color-state-secondary: rgba(27, 27, 29, 0.24);
    --color-state-tertiary: rgba(48, 49, 48, 0.07);

    --color-outline: var(--color-black);

    /* Home Page */
    --home-hero-background: linear-gradient(135deg, #950101 0%, #AB0101 100%);
    --home-hero-title-color: white;
    --home-hero-subtitle-color: white;

    /* Subscription Page */
    --subscription-hero-background: #F2F2F6;
    --subscription-hero-title-color: black;
    --subscription-hero-subtitle-color: black;

    /* User Shortcuts */
    --color-outline-accent: #DD0000;
`;
